import { Text } from '@chakra-ui/react';
import isEmpty from 'lodash/isEmpty';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import getCountText from 'utils/getCountText';
import { ChatMessage } from 'model/modules/chat/chatMessage';

interface Props {
  lastMessage: ChatMessage;
}

const ChatListLastMessageText: FC<Props> = ({ lastMessage }) => {
  const { t } = useTranslation();

  let text;
  if (lastMessage.text) {
    text = lastMessage.text;
  } else if (!isEmpty(lastMessage.files)) {
    const fileCount = lastMessage.files.length;
    text = getCountText(
      [
        t('filesCount1', { count: fileCount }),
        t('filesCount2', { count: fileCount }),
        t('filesCount3', { count: fileCount }),
        t('filesCount4', { count: fileCount }),
      ],
      fileCount
    );
  }

  return (
    <Text
      noOfLines={2}
      flex="1"
      minW={0}
      whiteSpace="normal"
      overflowWrap="anywhere"
      wordBreak="break-word"
    >
      {text}
    </Text>
  );
};

export default ChatListLastMessageText;
